import {
    //  UserActionTypes,
    PartyQuerty,
    GET_PARTY_LIST,
    GET_SECURITY_PROFILE,
    INSERT_PARTY,
    GET_PARTY,
    UPDATE_PARTY,
    DELETE_PARTY,
    UPDATE_SEUCRITY_PROFILE_CONFIG,
    UPDATE_AGENT_PROFILE_AND_LOG_OUT,
    Party,
    GET_AIRLINE
} from './types'
import { GET_ONE, CREATE, GET_LIST } from 'react-admin';
import * as constants from '../../constants/index'

export const insertParty = (party: Party) => ({
    type: INSERT_PARTY,
    payload: { data: party },
    meta: { fetch: CREATE, resource: constants.ROUTES.API_PREFIX + '/agent/insert-party' },
});
export const updateParty = (party: Party) => ({
    type: UPDATE_PARTY,
    payload: { data: party },
    meta: { fetch: CREATE, resource: constants.ROUTES.API_PREFIX + '/agent/update-party' },
});
export const deleteParty = (party: Party) => ({
    type: DELETE_PARTY,
    payload: { data: party },
    meta: { fetch: CREATE, resource: constants.ROUTES.API_PREFIX + '/agent/delete-party' },
});
export const getParty = (partyCd: string) => ({
    type: GET_PARTY,
    meta: { fetch: GET_ONE, resource: constants.ROUTES.API_PREFIX + '/agent/get-party?partyCd=' + partyCd },
});

export const getPartyList = (query: PartyQuerty) => (
    {
        type: GET_PARTY_LIST,
        meta: { fetch: GET_LIST, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.AGENT.PARTY_LIST}` },
        payload: { filter: query },
    }
)

export const getSecurityProfile = () => ({
    type: GET_SECURITY_PROFILE,
    meta: { fetch: GET_ONE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.SECURITY.SECURITY_PROFILE}` },
})


export const updateSecurityProfileConfig = (config: string, req: any = {}) => {
    return {
        type: UPDATE_SEUCRITY_PROFILE_CONFIG,
        payload: { data: config, body: req },
        meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.AGENT.UPDATE_AGENT_PROFILE}` },
    }
}

export const updateAgentProfileAndLogOut = (completeLogout: boolean) => ({
    type: UPDATE_AGENT_PROFILE_AND_LOG_OUT,
    completeLogout,
});

export const getAirline = (airlineName: string) => ({
    type: GET_AIRLINE,
    meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.AIRLINE.GET_AIRLINE}` },
    payload: { data: { airlineName } }
});

export const addAccessors = (defaultColumns: Array<any>, newColumns: Array<any>) => {
    return newColumns.map((column: any) => {
        if (!column.accessor) {
            const cols = defaultColumns.filter((defaultColumn: any) => {
                if (defaultColumn.id === column.id && defaultColumn.Header === column.Header) {
                    return defaultColumn
                }
            });
            if (cols.length > 0) { column.accessor = cols[0].accessor; }
            else {
                column.accessor = ''
            }
        }

        return column;
    })
}